import { useState, useEffect, useMemo } from "react";
import { toast } from "react-toastify";
import { getSampleGroupingsData } from "../helpers/eirna_backend_helper"; 


export const useBatchConditions = (projectId) => {
  // State
  const [loading, setLoading] = useState(true);
  const [availableConditions, setAvailableConditions] = useState([]);
  const [existingGroups, setExistingGroups] = useState([]);
  const [selectedCond1, setSelectedCond1] = useState([]);
  const [selectedCond2, setSelectedCond2] = useState([]);
  
  const [apiData, setApiData] = useState({
    json_files: [],
    default_tran: "",
    seq_types: [],
    studies_dict: {},
    subgroup_present: false,
    organism: "",
    transcriptome: "",
    html_args: {},
  });

  // Fetch initial data to get conditions
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getSampleGroupingsData(projectId);
        setAvailableConditions(Object.keys(response.existing_groups));
        setExistingGroups(response.existing_groups);
        setApiData(response.json_files);
      } catch (err) {
        toast.error("Failed to load project conditions");
      } finally {
        setLoading(false);
      }
    };

    if (projectId) {
      fetchData();
    }
  }, [projectId]);

  // Generate unique pairs based on selections
  const jobPairs = useMemo(() => {
    const pairs = [];
    const seenPairs = new Set();

    selectedCond1.forEach((c1) => {
      selectedCond2.forEach((c2) => {
        if (c1 !== c2) {
          // Ensure the smaller element comes first to treat (A,B) and (B,A) as identical
          const first = c1 < c2 ? c1 : c2;
          const second = c1 < c2 ? c2 : c1;

          // Create a unique string key for the Set
          const pairKey = `${first}::${second}`;

          if (!seenPairs.has(pairKey)) {
            seenPairs.add(pairKey);
            pairs.push({ cond1: first, cond2: second });
          }
        }
      });
    });

    return pairs;
  }, [selectedCond1, selectedCond2]);

  // Handlers for Checkboxes
  const handleToggle = (condition, isCond1) => {
    const setter = isCond1 ? setSelectedCond1 : setSelectedCond2;
    setter((prev) =>
      prev.includes(condition)
        ? prev.filter((c) => c !== condition)
        : [...prev, condition]
    );
  };

  const handleSelectAll = (isCond1, select) => {
    const setter = isCond1 ? setSelectedCond1 : setSelectedCond2;
    setter(select ? availableConditions : []);
  };

  return {
    loading,
    apiData,
    availableConditions,
    existingGroups,
    selectedCond1,
    selectedCond2,
    jobPairs,
    handleToggle,
    handleSelectAll,
  };
};